import { render, staticRenderFns } from "./RoomSelector.vue?vue&type=template&id=54578e9c&scoped=true&"
import script from "./RoomSelector.vue?vue&type=script&lang=js&"
export * from "./RoomSelector.vue?vue&type=script&lang=js&"
import style0 from "./RoomSelector.vue?vue&type=style&index=0&id=54578e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54578e9c",
  null
  
)

export default component.exports